var map = {
	"./Logo-Park-01-150x150.png": 7501,
	"./barname_boodje.png": 8454,
	"./fanavari.png": 1220,
	"./pajhoohesh.png": 4653,
	"./pec.png": 818,
	"./senfrayane.png": 5926,
	"./wallet.png": 3299,
	"./zarinpall.png": 8369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4282;